import React from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

export default function PieGraph({ data }) {
  const COLORS = ["#ff5b5bff", "#46abf9ff", "#59d875ff", "#d99c0fff"];
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={400} height={400}>
        <Pie
          dataKey="value"
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
        >
          {data.map((item, index) => (
            <Cell key={`cell-${item.name}`} fill={COLORS[index]} />
          ))}
        </Pie>
        <Legend
          iconType="circle"
          iconSize={6}
          wrapperStyle={{ fontSize: "12px" }}
        />
        <Tooltip
          itemStyle={{ fontSize: "12px" }}
          contentStyle={{ padding: "5px" }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
